import "@/App.css";
import { ReactLenis } from "lenis/react";
import DoremigosLandingPage from "@/components/doremigos/DoremigosLandingPage";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <DoremigosLandingPage />
    </ReactLenis>
  );
}

export default App;
